import { useTileContext } from '../../../ProductSelection/utils/tile-context-utils'
import { TileLayoutContainer } from '../../TileLayoutContainer'
import { ProductCoupon } from '../TileHeader/ProductImageRenderer/ProductCoupon'
import { ProductTitle } from '../TileHeader/ProductTitle'

import classes from './TileSections.module.scss'

export const TileHeadline = () => {
  const {
    config: {
      generalTileConfiguration: { tileLayoutVariant }
    }
  } = useTileContext()

  const isTileImageVisible = tileLayoutVariant?.options?.find(
    (section) => section.key === 'image'
  )?.isVisible

  return (
    <TileLayoutContainer
      className={classes.titleContainer}
      tileLayoutSection="headline"
    >
      <ProductTitle />
      {!isTileImageVisible && <ProductCoupon isStatic />}
    </TileLayoutContainer>
  )
}
